import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Upload photo ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Remove ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppEdit = _resolveComponent("AppEdit")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_SharedProfilePictureUpload = _resolveComponent("SharedProfilePictureUpload")!
  const _component_SharedProfilePictureCrop = _resolveComponent("SharedProfilePictureCrop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["account-picture", [
      _ctx.variation && `account-picture--${_ctx.variation}`,
      _ctx.theme && `account-picture--${_ctx.theme}`
    ]])
    }, [
      (!_ctx.isSimpleVariation)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.variationTitle), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "account-picture__wrap",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickOnAvatar && _ctx.handleClickOnAvatar(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.dynamicPictureURL,
          alt: `${_ctx.isTeamAvatar ? _ctx.activeMembership?.teamProfile?.name : _ctx.userProfile.firstName}'s profile picture`
        }, null, 8, _hoisted_2),
        (_ctx.isSimpleVariation)
          ? (_openBlock(), _createBlock(_component_AppEdit, {
              key: 0,
              onClick: _ctx.handleEditModal
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isSimpleVariation)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 1,
            theme: "secondary",
            tabindex: "-1",
            size: "small",
            onClick: _ctx.handleEditModal
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.hasAvatar)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 2,
            onClick: _ctx.removeProfilePicture,
            loading: _ctx.removing,
            tabindex: "-1",
            theme: "secondary",
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick", "loading"]))
        : _createCommentVNode("", true)
    ], 2),
    (!_ctx.isInQueue)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_SharedProfilePictureUpload, {
            id: _ctx.id,
            title: _ctx.title,
            isInQueue: _ctx.isInQueue
          }, null, 8, ["id", "title", "isInQueue"]),
          _createVNode(_component_SharedProfilePictureCrop, {
            id: `${_ctx.id}-crop`,
            title: _ctx.title,
            isTeamAvatar: _ctx.isTeamAvatar,
            isInQueue: _ctx.isInQueue,
            isNewUser: _ctx.isNewUser
          }, null, 8, ["id", "title", "isTeamAvatar", "isInQueue", "isNewUser"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}